// javascript-obfuscator:disable
import dynamic from "next/dynamic";

// Dynamically import components
const SectionHeadingLink = dynamic(
  () => import("./_components/SectionHeadingLink"),
  { ssr: true }
);
const Image = dynamic(() => import("./_components/Image"), { ssr: true });
const FeaturedProducts = dynamic(
  () => import("../common/FeaturedProductListing"),
  {
    ssr: true,
  }
);
const Text = dynamic(() => import("./_components/Text"), { ssr: true });
const Spacebar = dynamic(() => import("./_components/Spacebar"), { ssr: true });
const Banner = dynamic(() => import("./_components/Banner"), { ssr: true });
const CustomerCare = dynamic(() => import("./_components/CustomerCare"), {
  ssr: true,
});
const RecipesForYou = dynamic(() => import("../../components/RecipeCorusel"), {
  ssr: true,
});
const Separator = dynamic(() => import("./_components/Separator"), {
  ssr: true,
});
const Multicards = dynamic(() => import("./_components/ProudlyCards"), {
  ssr: true,
});
const ColumnControl = dynamic(() => import("./_components/columnControl"), {
  ssr: true,
});
const Container = dynamic(() => import("./_components/Container"), {
  ssr: true,
});
const Accordion = dynamic(() => import("./_components/Accordian"), {
  ssr: true,
});
const Column =  dynamic(() => import("./_components/Column"),{
  ssr: true,
});
const singlevideo =  dynamic(() => import("./_components/Videos"),{
  ssr: true,
});

// Export a resolver function
export function getComponentBySlug(slug: string) {
  if (slug.startsWith("sectionheadinglink")) {
    return SectionHeadingLink;
  }
  if (slug.startsWith("banner")) {
    return Banner;
  }
  if (slug.startsWith("text")) {
    return Text;
  }
  if (slug.startsWith("spacebar")) {
    return Spacebar;
  }
  if (slug.startsWith("featuredproducts")) {
    return FeaturedProducts;
  }
  if (slug.startsWith("image")) {
    return Image;
  }
  if (slug.startsWith("recipesforyou")) {
    return RecipesForYou;
  }
  if (slug.startsWith("spacebar")) {
    return Spacebar;
  }
  if (slug.startsWith("separator")) {
    return Separator;
  }
  if (slug.startsWith("customercare")) {
    return CustomerCare;
  }
  if (slug.startsWith("multibscards")) {
    return Multicards;
  }
  if (slug.startsWith("columncontrol")) {
    return ColumnControl;
  }
  if (slug.startsWith("container")) {
    return Container;
  }
  if (slug.startsWith("accordion")) {
    return Accordion;
  }
  if(slug.startsWith("column")) {
    return Column;
  }
  if(slug.startsWith("singlevideo")) {
    return singlevideo;
  }

  return null;
}
